module.exports = __webpack_public_path__ + "img/video-btn.9373188f.svg";